import React from 'react';
import { Box, Grid, Card, CardContent, Typography, CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';

const AttributesPage = () => {
    const attributeCategories = [
        {
            name: "All Players Attributes",
            path: "/attributes/all",
            description: "View all players with their complete attributes - batters and pitchers combined"
        },
        {
            name: "Batter Attributes",
            path: "/attributes/batters",
            description: "Detailed batting attributes including hitting vs LHP/RHP, speed, and fielding metrics"
        },
        {
            name: "Pitcher Attributes",
            path: "/attributes/pitchers",
            description: "Comprehensive pitching attributes including velocity, movement, control, and pitch arsenal"
        }
    ];

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ mb: 4 }}>
                Player Attributes
            </Typography>

            <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
                Explore player builds and attributes for batters and pitchers
            </Typography>

            <Grid container spacing={3}>
                {attributeCategories.map((category, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 4
                                }
                            }}
                        >
                            <CardActionArea
                                component={Link}
                                to={category.path}
                                sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                            >
                                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
                                        {category.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                                        {category.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default AttributesPage;
